export default "__VITE_ASSET__BhqcO4jJ__"